import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiBFFComponent } from '@opallabs/api'
import { CATEGORY_KINDS } from '@opallabs/concepts'

type CategoryById = OpalApiBFFComponent<'timeline_category'>

export const categoryByIdFactory: Factory<CategoryById> =
  Factory.define<CategoryById>(({ sequence, params }) => {
    return {
      id: uuidV4(),
      title: `Mock ${params.kind === CATEGORY_KINDS.group_swimlane ? 'Group' : 'Swimlane'} ${sequence}`,
      kind: CATEGORY_KINDS.swimlane,
      position: sequence,
      chart_id: null,
      image_url: null,
      settings: {
        row_size: 'small' as const,
        view_mode: 'default' as const,
        type: null,
        template_id: null,
      },
    } satisfies CategoryById
  })

type CategoriesById = OpalApiBFFComponent<'category_hierarchy'>['by_id']
type CategoryHierarchy = OpalApiBFFComponent<'category_hierarchy'>['hierarchy']

export const composeCategoriesFromHierarchy = (hierarchy: CategoryHierarchy) =>
  hierarchy.reduce((categoriesById, hierarchyItem) => {
    const children = hierarchyItem.children
    if (children.length) {
      children.forEach(({ id }) => {
        categoriesById[id] = categoryByIdFactory.build({
          id,
          kind: CATEGORY_KINDS.swimlane,
        })
      })
    }

    categoriesById[hierarchyItem.id] = categoryByIdFactory.build({
      id: hierarchyItem.id,
      kind: children.length
        ? CATEGORY_KINDS.group_swimlane
        : CATEGORY_KINDS.swimlane,
    })
    return categoriesById
  }, {} as CategoriesById)

type CategoryHierarchyItem = CategoryHierarchy[number]

export const categoryHierarchyFactory: Factory<CategoryHierarchyItem> =
  Factory.define<CategoryHierarchyItem>(({ params }) => ({
    id: params.id ?? uuidV4(),
    children: params.children ?? [],
  }))

export const extractHierarchyIds = (hierarchy: CategoryHierarchy) =>
  hierarchy.flatMap(({ id, children }) => {
    if (children.length) {
      // Ideally this would be recursive through children, but CategoryHierarchy
      // typing return children as unknown[] after one generation depth
      const childIds = children.map(({ id }) => id)
      return [id, ...childIds]
    }
    return [id]
  })
